module.exports = __webpack_public_path__ + "static/media/banner_logo.a7c13efb.png";